import { BlastEvent, Vector2D, ShapeType } from '@/types';

export class BlastEventPool {
  private pool: BlastEvent[] = [];

  constructor(initialSize: number = 500) {
    for (let i = 0; i < initialSize; i++) {
      this.pool.push(this.createEmptyEvent());
    }
  }

  private createEmptyEvent(): BlastEvent {
    return {
      id: '',
      pos: { x: 0, y: 0 },
      startTime: 0,
      duration: 0,
      maxRadius: 0,
      color: '',
      animationType: '',
      intensity: 0,
      shape: undefined,
      rotation: 0
    };
  }

  get(
    id: string,
    pos: Vector2D,
    startTime: number,
    duration: number,
    maxRadius: number,
    color: string,
    animationType: string,
    intensity: number,
    shape?: ShapeType,
    rotation?: number
  ): BlastEvent {
    let event = this.pool.pop();
    if (!event) {
      event = this.createEmptyEvent();
    }

    event.id = id;
    event.pos.x = pos.x;
    event.pos.y = pos.y;
    event.startTime = startTime;
    event.duration = duration;
    event.maxRadius = maxRadius;
    event.color = color;
    event.animationType = animationType;
    event.intensity = intensity;
    event.shape = shape;
    event.rotation = rotation || 0;

    return event;
  }

  release(event: BlastEvent) {
    this.pool.push(event);
  }

  getAvailableCount(): number {
    return this.pool.length;
  }
}
